import { Component } from 'react';

import Header from 'components/ui/Header';
import Navbar from 'components/ui/Navbar';
import CompanySelect from 'components/users/CompanySelect';

import UserAboutForm from 'components/users/UserAboutForm';
import UserAvatarForm from 'components/users/UserAvatarForm';
import AuthContext from 'providers/auth';
import { withTranslation } from 'react-i18next';

class ProfilePage extends Component {
  static contextType = AuthContext;

  render() {
    const { t } = this.props;
    const user = this.context.me;

    return (
      <>
        <Header>
          <h2 className="m-0 p-0 fw-lighter">{t('profile.title')}</h2>
        </Header>

        <div className="container mt-4 mb-4 d-md-none">
          <Navbar className="lg mb-4" />
          <div className="d-flex align-items-center">
            Empresa <CompanySelect />
          </div>
        </div>

        <div className="container mt-4">
          <div className="row">
            <div className="col-md-4 mb-3">
              <UserAvatarForm user={user} type="user" />
            </div>

            <div className="col-md-4 mb-3">
              <UserAboutForm user={user} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(ProfilePage);
